<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="4")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              TocButtons(:item="item")
          .field-value(slot="n1") TOC{{item.id}}
          .field-value(slot="n1") {{item.name}}
          .field-value(slot="n2") Required from
          .field-value(slot="n2") {{item.required_from}}
          .field-value(slot="n3") Disabled
          .field-value(slot="n3") {{item.disabled}}
          .field-value(slot="n4") Version
          .field-value(slot="n4") {{item.version}}
          .field-url-detail(slot="actionPage")
            router-link(:to="{name:'toc', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action

</template>
<script type="text/babel">
  import CardN from 'components/structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import VehicleCostButtons from '../structure/ui/actions/VehicleCostButtons'
  import VehicleNoteButtons from '../structure/ui/actions/VehicleNoteButtons'
  import {mapState} from 'vuex'
  import TocButtons from "../structure/ui/actions/TocButtons";

  export default {
    name: "Toc",
    components: {
      TocButtons,
      VehicleNoteButtons,
      VehicleCostButtons,
      Dropdown,
      CardN,
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {
    },
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// Toc.vue?6ff46dc4